/*
 * 开放状态与排队名单。
 *
 * 背景：2026-09-10 用户裁决——线上先只上一道拦截：「就算他登录了之后，也是跟他说排队中，
 *   然后让他点击一个排队按钮，然后就可以了。这个功能会在最近的一天内开放，如果功能开放了，
 *   我们会通过短信或者邮件通知你。」
 *
 * 设计意图：开关在服务端（网关的 gw_system_config），不在前端。前端写死的话，
 *   「最近一天内开放」就要等一次发版加一次 CDN 缓存过期，而那句话是对用户说的。
 *   这里只负责问一次、把答案交给页面。
 *
 * 关键约束：
 *   1. **问不到就当开着**。网关不可用、字段缺失、离线，一律按开放处理——真正拦人的是
 *      换票那一跳（它会回 `not_open_yet`，页面据此弹同一张排队屏）。反过来写成
 *      「问不到就当关着」，网关抖一下所有人都会看到「还没开放」，而它其实开着。
 *   2. 只在开页问一次。开放这件事一天内只会发生一次，为它轮询不值当；
 *      真开放了而某个人的页面还开着，他上传时换票会成功，那一刻状态自然就对了。
 */

export interface WaitlistState {
  /** 工具开没开放。问不到时是 true（见上面第 1 条）。 */
  open: boolean
  /** 这个账号排上了没有。未登录恒为 false。 */
  joined: boolean
}

const OPEN_BY_DEFAULT: WaitlistState = { open: true, joined: false }

/** 带上鉴权头才问得到 `joined`（未登录只回 open）。 */
export async function fetchWaitlist(
  headers: Record<string, string>, signal?: AbortSignal,
): Promise<WaitlistState> {
  try {
    const resp = await fetch('/gateway/tools/ripple/waitlist', { headers, signal })
    if (!resp.ok) return OPEN_BY_DEFAULT
    const d = await resp.json()
    return { open: d?.open !== false, joined: !!d?.joined }
  } catch {
    return OPEN_BY_DEFAULT
  }
}

/**
 * 排上队。回 true 表示名单里有他了（重复点也是 true，服务端幂等）。
 *
 * 失败要让调用方知道：这颗按钮是这一屏唯一的动作，默默失败等于让人以为排上了，
 * 然后一直等一条不会来的短信。
 */
export async function joinWaitlist(headers: Record<string, string>): Promise<boolean> {
  try {
    const resp = await fetch('/gateway/tools/ripple/waitlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...headers },
    })
    if (!resp.ok) return false
    return !!(await resp.json())?.joined
  } catch {
    return false
  }
}
